<template>
	<v-content>
		<v-container width="100%" ml-auto mr-auto pl-0 pr-0 pb-10>
			<v-stepper v-model="step">
				<v-stepper-header>
					<v-stepper-step :complete="step > 1" step="1">{{ $lib.translate('Шаг 1') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 2" step="2">{{ $lib.translate('Шаг 2') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="3">{{ $lib.translate('Шаг 3') }}</v-stepper-step>
				</v-stepper-header>
				<v-stepper-items>
					<v-stepper-content step="1">
						<SearchStep1/>
					</v-stepper-content>
					<v-stepper-content step="2">
						<SearchStep2/>
						<v-btn color="normal" @click="setStep(1)" class="mt-4">{{ $lib.translate('Назад') }}</v-btn>
					</v-stepper-content>
					<v-stepper-content step="3">
						<SearchStep3/>
						<v-btn color="normal" @click="setStep(2)" class="mt-4">{{ $lib.translate('Назад') }}</v-btn>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>
  	</v-content>
</template>

<script>
import SearchStep1 from '../components/SerachStep1';
import SearchStep2 from '../components/SerachStep2';
import SearchStep3 from '../components/SerachStep3';

export default {
	name: 'Search',

	components: {
		SearchStep1,
		SearchStep2,
		SearchStep3
	},

  	computed: {
		step () {
			return this.$store.getters.GET_STEP;
		}
	},

	methods: {
		setStep (index) {
			this.$store.dispatch('SET_STEP', index);
		}
	}
}
</script>

<style lang="scss">
</style>
